import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useEffect} from 'react'

import {RcfaComplianceHierarchyDto} from '../types'

const QueryKey = 'rcfa-compliance'

type RcfaComplianceParams = {
  from?: string
  to?: string
}

export const useRcfaCompliance = <TSelect = RcfaComplianceHierarchyDto[]>(
  {from, to}: RcfaComplianceParams,
  options?: Omit<
    UseQueryOptions<RcfaComplianceHierarchyDto, AxiosError, TSelect>,
    'queryKey' | 'queryFn'
  > & {
    onError?: (error: AxiosError) => void
  }
) => {
  const query = useQuery<RcfaComplianceHierarchyDto, AxiosError, TSelect>({
    queryKey: [QueryKey, from, to],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.get('/rcfa-compliance/api/rcfa-compliance', {
        params: {
          from,
          to
        },
        signal
      })

      return response.data
    },
    ...options
  })

  const onError = options?.onError

  useEffect(() => {
    if (query.error) {
      onError?.(query.error)
    }
  }, [query.error, onError])

  return query
}
